import { createSelector } from 'reselect';
import { getOrgCountryConfig } from '../orgConfigSelectors';

export const getSpanSeasons = createSelector(getOrgCountryConfig, (orgCountryConfig) => {
  return orgCountryConfig?.SpanSeason ?? undefined;
});
